import { Box, Button, Card, FormControl, FormLabel, IconButton, Stack, Typography } from '@mui/material';
import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AbsForm from '../../abstract/Form';
import { useApi } from '../../contexts/ApiContext';
import { useApp } from '../../contexts/AppContext';
import { useAuth } from '../../contexts/AuthContext';
import { useError } from '../../contexts/ErrorContext';
import { FormProvider } from '../../contexts/FormContext';
import { useResource } from '../../contexts/ResourceContext';
import { config } from './config';
import { FormData, FormResponse, IVFItem, schema } from './types';
import CardWithHeader from '../../components/cards/CardWithHeader';
import { Delete, Trash } from 'lucide-react';
import DateInput from '../../components/inputs/DateInput';
import { parseISO, set } from 'date-fns';
import { useTheme } from 'styled-components';

interface ImplantationWindowFormProps {
}

const onMessage = (message: any) => {
    console.info("message", message);
}

const ImplantationWindowForm: React.FC<ImplantationWindowFormProps> = (props) => {

    const { updateBreadcrumbs, updateActions } = useApp();
    const { showError } = useError();
    // const { updateResponse } = useResource<FormData, FormResponse>();
    const navigate = useNavigate();
    const { user, session } = useAuth();
    const theme = useTheme();
    const [formData, updateFormData] = React.useState<any>();
    const [ivfHistory, setIvfHistory] = React.useState<IVFItem[]>([
        {
            date: null,
            outcome: null
        }
    ]);

    console.info("user", user);

    useEffect(() => {

        updateBreadcrumbs([{
            label: "Implantation Window", onClick: () => {
                // navigate("/implantation");
            }
        }, {
            label: "New Assessment"
        }]);

        updateActions([
            <IconButton key={"submit"} onClick={handleSubmit}>Submit</IconButton>
        ]);

        return () => {
            updateBreadcrumbs([]);
            updateActions([]);
        }

    }, []);

    const getFormData = () => {
        return formData;
    }


    const { apiService } = useApi();

    const handleSubmit = useCallback(async () => {


        console.info("handleSubmit formData", getFormData());

        try {

            const response = await apiService.put<FormResponse, FormData>("/implantation", getFormData() as any);
            console.log("API Response:", response);

            // navigate(`/implantation/${response.cycle.id}/analysis`);
        } catch (error) {
            console.error("Error submitting form", error);
            showError("Error submitting form");
        }


    }, [formData]);

    const handleDataChange = (data: any) => {
        console.info("data", data);
        updateFormData(data as FormData);
    }

    return (
        <FormProvider>
            <Stack gap={3} direction={"row"}>
                <Stack gap={2} width={"60%"}>
                    <AbsForm
                        langCategory='implantation'
                        system={"metric"}
                        data={{}}
                        initialValues={{}}
                        config={config}
                        onSubmit={handleSubmit}
                        schema={schema}
                        onChange={handleDataChange}
                        submitText='Submit for analysis'
                    />

                    <CardWithHeader id={"ivf-history"} headerColor={"white"} title={"IVF History"}>
                        <React.Fragment>
                            {ivfHistory.map((item, index) => (
                                <Card key={index} sx={{ padding: theme.spacing(2) }}>
                                    <Stack gap={2}>
                                        <Stack gap={1} justifyContent={"space-between"} direction={"row"}>
                                            <Typography variant={"body1"}>{`Cycle ${index + 1}`}</Typography>
                                            <IconButton onClick={() => setIvfHistory((prev) => {
                                                if (prev.length === 1) {
                                                    return prev;
                                                }
                                                const updated = [...prev];
                                                updated.splice(index, 1);
                                                return updated;
                                            })}>
                                                <Trash />
                                            </IconButton>
                                        </Stack>
                                        <DateInput
                                            label={"Date of embryo transfer"}
                                            value={ivfHistory[index].date}
                                            onChange={(value) => setIvfHistory((prev) => {
                                                const updated = [...prev];
                                                updated[index].date = value;
                                                return updated;
                                            })}
                                        />
                                    </Stack>
                                </Card>
                            ))}
                            <Button onClick={() => setIvfHistory((prev) => [...prev, { date: null, outcome: null }])}>+ Add another cycle</Button>
                        </React.Fragment>
                    </CardWithHeader>
                </Stack>


            </Stack >
        </FormProvider>
    );
};

export default ImplantationWindowForm;
